export enum ESettingsRoutes {
  SETTINGS = 'Settings'
}
